import { createContext, useContext } from 'react';
import { SignupState } from '../types';

export type SignupStepContextValue = {
  companyId: string;
  funnel: SignupState;
};

/**
 * What the step route resolved before it rendered the screen: the company the client is in, and the funnel as
 * the API described it. Null only outside such a route, which is a wiring mistake rather than a state a client
 * can reach — hence the throw below, and neither field nullable for the screens.
 */
export const SignupStepContext = createContext<SignupStepContextValue | null>(null);

export const useSignupStep = (): SignupStepContextValue => {
  const step = useContext(SignupStepContext);
  if (step == null) throw new Error('A signup step screen was rendered outside SignupStepRoute');

  return step;
};
